import {Component,OnInit, ViewChild} from '@angular/core';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatDrawerMode, MatSidenav, MatSidenavModule} from '@angular/material/sidenav';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {RouterLink, RouterOutlet} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import { map } from 'rxjs/operators';
import { HeaderComponent } from '../header/header.component';
import { SideMenuComponent } from '../side-menu/side-menu.component';

@Component({
  selector: 'app-layout',
  imports: [MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    RouterOutlet,
    MatButtonModule,
   HeaderComponent,
    SideMenuComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {mode: MatDrawerMode = 'side';
  opened = false;
  fixedInViewport = true;
  layoutGap = '64';
  isFullScreen = false;
  @ViewChild('sidenav', { static: true }) sidenav!: MatSidenav;

  constructor(private breakpointObserver: BreakpointObserver) {

  }
  

  toggleFullScreen(): void {
    this.isFullScreen = !this.isFullScreen;
  }

  public ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset])
    .pipe(map(bst => bst.matches))
    .subscribe(matched => {
      this.determineSidenavMode();
      this.determineLayoutGap();
    });
  }

  private determineSidenavMode(): void {
    if (
        this.isExtraSmallDevice() ||
        this.isSmallDevice()
    ) {
        this.fixedInViewport = false;
        this.mode = 'over';
        this.opened = false;
        return;
    }

    this.fixedInViewport = true;
    this.mode = 'over';
}

private determineLayoutGap(): void {
    if (this.isExtraSmallDevice() || this.isSmallDevice()) {
        this.layoutGap = '0';
        return;
    }

    this.layoutGap = '64';
}

  public isExtraSmallDevice(): boolean {
    return this.breakpointObserver.isMatched(Breakpoints.XSmall);
  }

  public isSmallDevice(): boolean {
    return this.breakpointObserver.isMatched(Breakpoints.Small)
  }
}
